export const callButton = {
    callButtonMainPage: {
        rbmail: {
            type: 'click',
            id: '9275288',
        },
    },
    callButtonConsultation: {
        rbmail: {
            type: 'click',
            id: '92753065',
        },
    },
    callButtonExpertQuote: {
        rbmail: {
            type: 'click',
            id: '92753071',
        },
    },
};
